import { render, staticRenderFns } from "./Commission.vue?vue&type=template&id=7a6171d5&scoped=true&"
import script from "./Commission.vue?vue&type=script&lang=js&"
export * from "./Commission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6171d5",
  null
  
)

export default component.exports